import angular from 'angular';

import coreModuleConfig from './core.config';

import ApiService from './services/api.service';
import CoreService from './services/core.service';

import helpController from './controllers/help.ctrl';

import feetDirective from './directives/feet';
import howtoregisterDirective from './directives/howtoregister';
import panelCollapseDirective from './directives/panelCollapse';
import bgEntityImg from './directives/bgEntityImg';
import elEntityImg from './directives/elEntityImg';

const coreModule = angular.module('com.module.core', []);

coreModule.config(coreModuleConfig);

coreModule.service('ApiService', ApiService);
coreModule.service('CoreService', CoreService);

coreModule.controller('HelpCtrl', helpController);

coreModule.directive('feet', feetDirective);
coreModule.directive('howtoregister', howtoregisterDirective);
coreModule.directive('panelCollapse', panelCollapseDirective);
coreModule.directive('bgEntityImg', bgEntityImg);
coreModule.directive('elEntityImg', elEntityImg);

export default coreModule;



// WEBPACK FOOTER //
// ./js/containers/core/index.js